var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/audio-video-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container video-modal ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    ";
if(runtime.contextOrFrameLookup(context, frame, "jsAudioMpthreeFile")) {
output += "\n    <div class=\"modal__audio-container\">\n        <div class=\"modal__audio-player\">\n            ";
output += "\n            <audio autoplay=\"true\" controls controlsList=\"nodownload\">\n                <source src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsAudioMpthreeFile"), env.opts.autoescape);
output += "\" type=\"audio/mp3\">\n                ";
output += "\n            </audio>\n        </div>\n    </div>\n    ";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "jsSpotifyId")) {
output += "\n    <div class=\"modal__audio-container\">\n        <div class=\"modal__audio-player\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "jsSlideType") == "spotify_playlist") {
output += "\n                <iframe src=\"https://open.spotify.com/embed/playlist/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSpotifyId"), env.opts.autoescape);
output += "\" width=\"300\" height=\"380\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe>\n            ";
;
}
else {
output += "\n                <iframe src=\"https://open.spotify.com/embed/track/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSpotifyId"), env.opts.autoescape);
output += "\" width=\"300\" height=\"380\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe>\n            ";
;
}
output += "\n        </div>\n    </div>\n    ";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "jsSoundcloudId")) {
output += "\n    <div class=\"modal__audio-container\">\n        <div class=\"modal__audio-player\">\n            <iframe width=\"100%\" height=\"300\" scrolling=\"no\" frameborder=\"no\" allow=\"autoplay\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSoundcloudId"), env.opts.autoescape);
output += "&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true\"></iframe>\n        </div>\n    </div>\n    ";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "jsYtVideoId")) {
output += "\n    <div class=\"modal__video-container\">\n        <div class=\"embed-responsive embed-responsive-16by9\">\n            <iframe class=\"embed-responsive-item\" src=\"https://www.youtube.com/embed/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsYtVideoId"), env.opts.autoescape);
output += "?autoplay=1&rel=0&enablejsapi=1\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n\n            <script src=\"https://www.youtube.com/iframe_api\"></script>\n        </div>\n    </div>\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "jsVimeoVideoId")) {
output += "\n    <div class=\"modal__video-container\">\n        <div class=\"embed-responsive embed-responsive-16by9\">\n            <iframe src=\"https://player.vimeo.com/video/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsVimeoVideoId"), env.opts.autoescape);
output += "?autoplay=1\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n        </div>\n    </div>\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "jsNativeVideoFile")) {
output += "\n    <div class=\"modal__video-container\">\n        <div class=\"embed-responsive embed-responsive-16by9\">\n            <video autoplay=\"true\" controls controlsList=\"nodownload\">\n                <source src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsNativeVideoFile"), env.opts.autoescape);
output += "\" type=\"audio/mp4\">\n            </video>\n        </div>\n    </div>\n    ";
;
}
;
}
;
}
output += "\n    <div class=\"modal__text-container\">\n        <h1 class=\"modal__title\" data-auto-translate=\"true\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n        </h1>\n        <div class=\"modal__text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsText"))), env.opts.autoescape);
output += "</div>\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/audio-video-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/audio-video-view.njk
// module id = 482
// module chunks = 0